import { render, staticRenderFns } from "./itemTagList.vue?vue&type=template&id=7b5ba560"
import script from "./itemTagList.vue?vue&type=script&lang=js"
export * from "./itemTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports